module.exports = __webpack_public_path__ + "img/team2.e51c979f.png";